/* Ajout rapide au panier depuis les cartes produit (survol), puis ouverture du panier latéral.
   Reprend le protocole d'Horizon : un CartLinesUpdateEvent « add » dont la promesse porte
   le rendu des sections du panier ; le panier latéral s'ouvre de lui-même (réglage auto-open). */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

async function ajouter(bouton, idVariante = bouton.dataset.rdpAjouter, racine = bouton.closest('[data-rdp-ajout-rapide]'), options = [], quantite = 1, proprietes = {}) {
  /* les options (passagers, déjeuners) partent dans la même requête ; le billet est ajouté en dernier pour rester au-dessus d'elles dans le panier.
     proprietes : champs remplis sur la fiche (véhicule d'un rallye), enregistrés sur la ligne du billet */
  const billet = { id: Number(idVariante), quantity: quantite };
  if (Object.keys(proprietes).length) billet.properties = proprietes;
  const articles = [...options, billet];
  const sections = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const differe = CartLinesUpdateEvent.createPromise();
  bouton.disabled = true;
  bouton.classList.add('est-en-cours');

  racine.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: articles.map((a) => ({ merchandiseId: String(a.id), quantity: a.quantity })),
    promise: differe.promise,
  }));

  try {
    const reponse = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: articles, sections: sections.join(',') }),
    }).then((r) => r.json());
    const panier = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
    const erreur = Boolean(reponse.status);
    differe.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(panier),
      detail: {
        items: panier.items,
        source: 'product-form-component',
        sourceId: `rdp-${racine.dataset.produit}`,
        itemCount: articles.reduce((t, a) => t + a.quantity, 0),
        productId: racine.dataset.produit,
        sections: reponse.sections,
        didError: erreur,
      },
    });
    bouton.classList.add(erreur ? 'est-erreur' : 'est-ajoute');
    /* Si l'ouverture automatique du panier est coupée dans les réglages, on l'ouvre quand même. */
    if (!erreur) {
      requestAnimationFrame(() => {
        const tiroir = document.querySelector('cart-drawer-component')?.closest('theme-drawer');
        if (tiroir && !tiroir.isOpen) tiroir.open?.();
      });
    }
    if (erreur && reponse.description) bouton.title = reponse.description;
  } catch (e) {
    differe.reject(e);
    bouton.classList.add('est-erreur');
  } finally {
    bouton.classList.remove('est-en-cours');
    setTimeout(() => { bouton.disabled = false; bouton.classList.remove('est-ajoute', 'est-erreur'); }, 1800);
  }
}

document.addEventListener('click', (e) => {
  const ouvrir = e.target.closest('[data-rdp-choix-ouvrir]');
  if (ouvrir) {
    e.preventDefault();
    const liste = ouvrir.closest('[data-rdp-ajout-rapide]')?.querySelector('.rdp-ajout-rapide__choix');
    const ouvert = ouvrir.getAttribute('aria-expanded') === 'true';
    ouvrir.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
    if (liste) liste.hidden = ouvert;
    return;
  }
  /* un clic ailleurs referme les listes de déclinaisons ouvertes */
  document.querySelectorAll('[data-rdp-choix-ouvrir][aria-expanded="true"]').forEach((b) => {
    if (b.closest('[data-rdp-ajout-rapide]')?.contains(e.target)) return;
    b.setAttribute('aria-expanded', 'false');
    const l = b.closest('[data-rdp-ajout-rapide]')?.querySelector('.rdp-ajout-rapide__choix');
    if (l) l.hidden = true;
  });
  const bouton = e.target.closest('[data-rdp-ajouter]');
  if (!bouton) return;
  e.preventDefault();
  ajouter(bouton);
});

/* Fiche billet : choix de la déclinaison (prix, disponibilité) et ajout au panier latéral. */
/* Reprend tous les formats de prix de Shopify (Paramètres › Général), pour afficher le même prix que le serveur. */
function formatPrix(centimes, format) {
  const groupe = (n, separateur) => n.replace(/\B(?=(\d{3})+(?!\d))/g, separateur);
  const [entier, decimales] = (centimes / 100).toFixed(2).split('.');
  const arrondi = String(Math.round(centimes / 100));
  const styles = {
    amount: () => `${groupe(entier, ',')}.${decimales}`,
    amount_no_decimals: () => groupe(arrondi, ','),
    amount_with_comma_separator: () => `${groupe(entier, '.')},${decimales}`,
    amount_no_decimals_with_comma_separator: () => groupe(arrondi, '.'),
    amount_with_apostrophe_separator: () => `${groupe(entier, "'")}.${decimales}`,
    amount_no_decimals_with_space_separator: () => groupe(arrondi, '\u00a0'),
    amount_with_space_separator: () => `${groupe(entier, '\u00a0')},${decimales}`,
    amount_with_period_and_space_separator: () => `${groupe(entier, '\u00a0')}.${decimales}`,
  };
  return (format || '{{amount}} €').replace(/\{\{\s*(\w+)\s*\}\}/, (m, cle) => (styles[cle] || styles.amount)());
}

document.querySelectorAll('[data-rdp-formulaire-panier]').forEach((racine) => {
  const section = racine.closest('section');
  const donnees = JSON.parse(section?.querySelector('[data-rdp-variantes]')?.textContent || '{}');
  const variantes = donnees.produit?.variants || [];
  const formulaire = racine.querySelector('form');
  const champ = racine.querySelector('[data-rdp-variante]');
  const bouton = racine.querySelector('[data-rdp-bouton-panier]');
  /* Nombre de billets (1 par défaut, au plus le stock restant) et options du billet : de 0 au maximum par billet
     multiplié par le nombre de billets ; au-delà, le message du produit s'affiche */
  const options = [...racine.querySelectorAll('[data-rdp-option-billet]')];
  const blocQte = racine.querySelector('[data-rdp-quantite-billets]');
  let variante = variantes.find((x) => String(x.id) === String(champ?.value)) || variantes[0];
  const nbBillets = () => Number(blocQte?.querySelector('[data-rdp-qte-nombre]').textContent) || 1;
  const stockMax = () => { const st = donnees.stocks?.[variante?.id]; return typeof st === 'number' ? Math.max(1, Math.min(st, 50)) : 50; };
  const quantite = (o) => Number(o.querySelector('[data-rdp-option-nombre]').textContent) || 0;
  const totalOptions = () => options.reduce((t, o) => t + quantite(o) * Number(o.dataset.prix), 0);
  const majTotal = () => {
    const el = section.querySelector('[data-rdp-prix-bouton]');
    if (el && variante) el.textContent = formatPrix(variante.price * nbBillets() + totalOptions(), donnees.format);
  };
  const reglages = [];
  const reglerQte = (n) => {
    if (!blocQte) return;
    const max = stockMax();
    const q = Math.max(1, Math.min(n, max));
    blocQte.querySelector('[data-rdp-qte-nombre]').textContent = q;
    blocQte.querySelector('[data-rdp-qte-moins]').disabled = q <= 1;
    blocQte.querySelector('[data-rdp-qte-plus]').disabled = q >= max || !variante?.available;
    /* moins de billets : les options en trop sont retirées */
    reglages.forEach((r) => r());
    majTotal();
  };
  if (blocQte) {
    blocQte.querySelector('[data-rdp-qte-moins]').addEventListener('click', () => reglerQte(nbBillets() - 1));
    blocQte.querySelector('[data-rdp-qte-plus]').addEventListener('click', () => reglerQte(nbBillets() + 1));
    reglerQte(1);
  }
  options.forEach((o) => {
    const nombre = o.querySelector('[data-rdp-option-nombre]');
    const moins = o.querySelector('[data-rdp-option-moins]');
    const message = o.querySelector('[data-rdp-option-message]');
    const parBillet = Number(o.dataset.max) || 9;
    reglages.push(() => { const max = parBillet * nbBillets(); if (quantite(o) > max) { nombre.textContent = max; o.classList.toggle('est-choisie', max > 0); } });
    const regler = (n) => {
      const max = parBillet * nbBillets();
      if (n > max) { if (message) message.hidden = false; return; }
      if (message) message.hidden = true;
      nombre.textContent = Math.max(0, n);
      moins.disabled = n <= 0;
      o.classList.toggle('est-choisie', n > 0);
      majTotal();
    };
    moins.addEventListener('click', () => regler(quantite(o) - 1));
    o.querySelector('[data-rdp-option-plus]').addEventListener('click', () => regler(quantite(o) + 1));
  });
  const majPrix = (v) => {
    variante = v;
    section.querySelectorAll('[data-rdp-prix-actuel], [data-rdp-prix-bouton]').forEach((el) => { el.textContent = formatPrix(v.price, donnees.format); });
    reglerQte(nbBillets());
    majTotal();
    const barre = section.querySelector('[data-rdp-prix-barre]');
    if (barre) { barre.hidden = !(v.compare_at_price > v.price); barre.textContent = formatPrix(v.compare_at_price || 0, donnees.format); }
    if (bouton) {
      bouton.disabled = !v.available;
      const libelle = bouton.querySelector('[data-rdp-libelle-bouton]');
      if (libelle) libelle.textContent = v.available ? (bouton.dataset.libelle || libelle.textContent) : (bouton.dataset.epuise || libelle.textContent);
    }
  };
  if (bouton) {
    const libelle = bouton.querySelector('[data-rdp-libelle-bouton]');
    bouton.dataset.libelle = libelle?.textContent || '';
  }
  racine.querySelectorAll('[data-rdp-option]').forEach((radio) => radio.addEventListener('change', () => {
    const choix = [...racine.querySelectorAll('[data-rdp-option]:checked')].map((r) => r.value);
    const v = variantes.find((x) => x.options.every((o, i) => o === choix[i]));
    if (!v) return;
    champ.value = v.id;
    majPrix(v);
    /* le visuel rattaché à la variante choisie remplace celui des autres variantes */
    const media = String(v.featured_media?.id || '');
    section.querySelectorAll('[data-rdp-media-variante]').forEach((el) => { el.hidden = el.dataset.rdpMediaVariante !== media; });
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState(null, '', url);
  }));
  formulaire?.addEventListener('submit', (e) => {
    if (!bouton) return;
    e.preventDefault();
    racine.dataset.produit = racine.dataset.produit || donnees.produit?.id;
    /* chaque option choisie est rattachée au billet : nom du billet visible dans le panier et la commande, identifiant caché pour le ménage */
    const choisies = options.filter((o) => quantite(o) > 0).map((o) => ({
      id: Number(o.dataset.variante),
      quantity: quantite(o),
      /* _max : options par billet au plus, pour les répartir billet par billet (e-mail, « Mes billets », scan) */
      properties: { [racine.dataset.libelleBillet || 'Billet']: racine.dataset.titre || '', _option_de: String(champ.value), _max: String(Number(o.dataset.max) || '') },
    }));
    /* champs de la fiche (véhicule d'un rallye) : name="properties[…]", obligatoires (le navigateur bloque l'envoi s'ils sont vides) */
    const proprietes = {};
    racine.querySelectorAll('[data-rdp-propriete]').forEach((c) => {
      const cle = (c.name.match(/^properties\[(.+)\]$/) || [])[1];
      if (cle && c.value.trim()) proprietes[cle] = c.value.trim();
    });
    ajouter(bouton, champ.value, racine, choisies, nbBillets(), proprietes).then(() => {
      options.forEach((o) => { o.querySelector('[data-rdp-option-nombre]').textContent = 0; o.querySelector('[data-rdp-option-moins]').disabled = true; o.classList.remove('est-choisie'); });
      racine.querySelectorAll('[data-rdp-propriete]').forEach((c) => { c.value = ''; });
      reglerQte(1);
    });
  });
});

/* Une option (passager, déjeuner) ne reste pas dans le panier sans son billet : si le billet est retiré, ses options le sont aussi.
   Et pas plus que « _max » par billet : si on retire un billet, ses options en trop partent avec lui. */
let menageEnCours = false;
async function retirerOptionsOrphelines() {
  if (menageEnCours) return;
  const racineUrl = window.Theme?.routes?.cart_url || '/cart';
  const panier = await fetch(`${racineUrl}.js`).then((r) => r.json());
  const billets = {};
  panier.items.forEach((i) => { if (!i.properties?._option_de) billets[i.variant_id] = (billets[i.variant_id] || 0) + i.quantity; });
  const corrections = {};
  panier.items.forEach((i) => {
    const de = i.properties?._option_de;
    if (!de) return;
    const n = billets[de] || 0;
    const max = Number(i.properties._max) || 0;
    if (!n) corrections[i.key] = 0;
    else if (max && i.quantity > max * n) corrections[i.key] = max * n;
  });
  const orphelines = panier.items.filter((i) => i.key in corrections);
  if (!orphelines.length) return;
  menageEnCours = true;
  const sections = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const differe = CartLinesUpdateEvent.createPromise();
  document.body.dispatchEvent(new CartLinesUpdateEvent({
    action: 'remove',
    context: 'cart',
    lines: orphelines.map((i) => ({ id: i.key, quantity: corrections[i.key] })),
    promise: differe.promise,
  }));
  try {
    const reponse = await fetch(`${racineUrl}/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: corrections, sections: sections.join(','), sections_url: window.location.pathname }),
    }).then((r) => r.json());
    differe.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(reponse),
      detail: { sections: reponse.sections, items: reponse.items, itemCount: reponse.item_count, source: 'rdp-options', didError: false },
    });
  } catch (e) {
    differe.reject(e);
  } finally {
    setTimeout(() => { menageEnCours = false; }, 400);
  }
}
document.addEventListener(StandardEvents.cartLinesUpdate, (e) => {
  e.promise?.then(({ detail }) => { if (detail?.source !== 'rdp-options') retirerOptionsOrphelines(); }).catch(() => {});
});

/* Compteurs du panier (pastille de l'en-tête, en-tête dédié), mis à jour à chaque changement du panier.
   Les options d'un billet font partie du billet : elles ne comptent pas comme des articles. */
document.addEventListener(StandardEvents.cartLinesUpdate, (e) => {
  e.promise?.then(async () => {
    const panier = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
    const n = panier.items.reduce((t, i) => t + (i.product_type === 'Option billet' && i.properties?._option_de ? 0 : i.quantity), 0);
    document.querySelectorAll('[data-rdp-compteur]').forEach((c) => { c.textContent = n; c.hidden = n === 0; });
    document.querySelectorAll('cart-icon').forEach((c) => c.renderCartBubble?.(n, false));
  }).catch(() => {});
});
